import { AutogenLayoutProspectActivityList } from "./autogen/AutogenLayoutProspectActivityList";

export class ProspectActivityList extends AutogenLayoutProspectActivityList {
    onLoad(): void | Promise<void> {
        this.tableProspectActivities.addButtonCaption = "Add Marketing Activity";
    }
}